import { Grid, IconButton, Theme } from '@mui/material';
import { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  SimpleSocialMedia,
  SocialMediaWithUrl,
  buildMediaUserUrl,
  socialMediasConfig,
} from '../../lib/SocialMedias';
import useWidth from '../Hooks/useWidth';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    marginLeft: theme.spacing(-1 / 4),
    [theme.breakpoints.only('xs')]: {
      marginLeft: 0,
    },
  },
  socialMediaLink: {
    color: theme.palette.text.secondary,
  },
  iconButton: {
    padding: theme.spacing(1 / 2),
  },
}));

export type SocialMediasSectionProps = {
  medias?: SimpleSocialMedia[];
};

const defaultMedias: SimpleSocialMedia[] = [];

const SocialMediasSection = ({ medias = defaultMedias }: SocialMediasSectionProps) => {
  const { classes } = useStyles();
  const { mobileWidth } = useWidth();

  const socialMedias: SocialMediaWithUrl[] = useMemo(() => {
    const computedSocialMedias: SocialMediaWithUrl[] = [];

    medias?.forEach((simpleSocialMedia) => {
      const socialMediaConfig = socialMediasConfig[simpleSocialMedia.name.toUpperCase()];
      if (socialMediaConfig) {
        computedSocialMedias.push({
          icon: socialMediaConfig.icon,
          url: buildMediaUserUrl(socialMediaConfig, simpleSocialMedia.userName),
        });
      }
    });

    return computedSocialMedias;
  }, [medias]);

  return (
    <Grid
      container
      spacing={1}
      className={classes.root}
      sx={{
        alignItems: 'center',
        justifyContent: mobileWidth ? 'center' : 'flex-start',
      }}
    >
      {socialMedias?.map((socialMediaWithUrl, index) => (
        <Grid key={`social-media-${index}`} size="auto">
          <a
            target="_blank"
            href={socialMediaWithUrl.url}
            rel="noreferrer"
            className={classes.socialMediaLink}
          >
            <IconButton size="small" className={classes.iconButton}>
              <socialMediaWithUrl.icon color="action" />
            </IconButton>
          </a>
        </Grid>
      ))}
    </Grid>
  );
};

export default SocialMediasSection;
